












import Vue from 'vue';
import OctAppBar from './components/app/OctAppBar.vue';
import OctMessageSnackBar from "@/components/app/OctMessageSnackBar.vue";

export default Vue.extend({
  name: 'App',
  components: {
    OctAppBar,
    OctMessageSnackBar
  },
  props: {
    source: String,
  },
  data: () => ({
  }),
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  }
});
